/**
 * i18n Configuration - YUL ON TAP
 * 
 * Phase 3: Bilingual support (English + French)
 * - Admin UI localization
 * - Guest-facing flow localization
 * - Export header localization
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import fr from './locales/fr.json';
import es from './locales/es.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      es: { translation: es },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'fr', 'es'],
    
    // Language detection options
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'yul_language',
    },
    
    // Strip region codes: en-US → en, es-MX → es, fr-CA → fr
    load: 'languageOnly',
    
    interpolation: {
      escapeValue: false, // React already escapes
    },
    
    // Return key if translation missing (helps identify gaps)
    returnEmptyString: false,
    returnNull: false,
  });

export default i18n;
